import { BaseContainerModel } from '../../../base-container.model';
import { bl_del_trip_hdr_RowClass, bl_del_trip_ext_RowClass } from '../../../../dbschema';

export class TripDeliveryHeaderContainerModel extends BaseContainerModel {
    bl_del_trip_hdr: bl_del_trip_hdr_RowClass = new bl_del_trip_hdr_RowClass();
    bl_del_trip_ext: bl_del_trip_ext_RowClass[] = [];
}